/* ============================================================
   LieblingsApotheken-Konditionen im Warenkorb (Stand 06.10.2026,
   Entscheidungen Sales). MUSS als LETZTE der Warenkorb-Dateien
   geladen werden (nach gc-partner-mode.js): legt sich um
   gcEnforceMengenrabatt() und laeuft damit nach allen anderen
   Rabattpruefungen.

   Wann ist ein Warenkorb "LieblingsApotheken"?
   Warenkorb-Attribut lieblings_flow = true UND kein anderer
   Partner-/Zielgruppenmodus aktiv (Aposanitas, Dental, gesund leben,
   Alliance Healthcare). Der zuletzt geoeffnete Partnerlink gilt.
   Gesetzt wird lieblings_flow nur durch den DIREKTEN Aufruf von
   /pages/lieblingsapotheken bzw. /lieblingsapotheken (nicht aus dem
   Shop heraus) oder durch die Wiedererkennung (snippets/gc-lieblings-bar.liquid).
   Von Hand eingegebene LieblingsApotheken-Codes werden ausserhalb
   dieses Modus wieder entfernt.

   Dann gilt (IMMER im Modus, auch bei Nachbestellungen ohne Geraet):
   - Igloo Reader Pro DC im Warenkorb: LIEBLINGSAPO20 (20 % aufs Geraet,
     einmal pro Kunde - in Shopify hinterlegt).
   - Staffel auf alle Testboxen (Collection testkits_neu):
       5-9 Boxen  -> LIEBLINGSAPO5  (5 %)
       10-14      -> LIEBLINGSAPO10 (10 %)
       ab 15      -> LIEBLINGSAPO15 (15 %)
     Sie ERSETZT die normale Staffel (NACHBESTELLUNG5/10).
   - Attribut "Partner: LieblingsApotheken" steht an der Bestellung.
   - Ist collabsCode gesetzt, laeuft der 0-%-Collabs-Code mit.

   Schwellen und Saetze stehen zusaetzlich in den Shopify-Rabatten,
   in snippets/gc-lieblings-cart.liquid und werden vom Rechner
   (assets/lieblings-configurator.js) aus window.gcLieblings gelesen.
   Aendert sich etwas, Shopify-Rabatte UND diese Datei UND das
   Warenkorb-Snippet anpassen.
   ============================================================ */
window.gcLieblings = Object.assign({
  dcVariantId: 59065942540613,        /* Igloo | Reader Pro DC */
  deviceRate: 20,
  deviceCode: 'LIEBLINGSAPO20',
  tiers: [                            /* absteigend sortiert */
    { min: 15, rate: 15, code: 'LIEBLINGSAPO15' },
    { min: 10, rate: 10, code: 'LIEBLINGSAPO10' },
    { min: 5,  rate: 5,  code: 'LIEBLINGSAPO5' }
  ],
  page: '/pages/lieblingsapotheken',
  collabsCode: ''                     /* 0-%-Code aus Shopify Collabs, sobald angelegt */
}, window.gcLieblings || {});

/* Staffelstufe fuer n Testboxen (oder null) */
function gcLieblingsTier(n){
  const tiers = window.gcLieblings.tiers;
  for(let i = 0; i < tiers.length; i++){
    if(n >= tiers[i].min) return tiers[i];
  }
  return null;
}

/* Naechsthoehere Stufe fuer n Testboxen (oder null, wenn schon die hoechste) */
function gcLieblingsNextTier(n){
  const tiers = window.gcLieblings.tiers.slice().sort((a, b) => a.min - b.min);
  for(let i = 0; i < tiers.length; i++){
    if(n < tiers[i].min) return tiers[i];
  }
  return null;
}

/* Ist der Warenkorb im LieblingsApotheken-Modus? Andere Modi haben Vorrang,
   weil sie nur durch einen spaeter geoeffneten Partnerlink gesetzt sein koennen. */
function gcLieblingsActive(attrs){
  attrs = attrs || {};
  if(attrs.lieblings_flow !== 'true') return false;
  if(attrs.aposanitas_flow === 'true') return false;
  if(attrs.dental_flow === 'true') return false;
  if(attrs.partner_flow === 'gesundleben' || attrs.partner_flow === 'ahd') return false;
  return true;
}

async function gcEnforceLieblings(){
  try{
    const C = window.gcLieblings;
    const root = window.Shopify.routes.root;
    const res = await fetch(root + 'cart.js');
    const cart = await res.json();
    const attrs = cart.attributes || {};
    const current = (cart.discount_codes || []).map(d => d.code);

    const own = [C.deviceCode, C.collabsCode].concat(C.tiers.map(t => t.code))
      .filter(Boolean).map(c => c.toUpperCase());
    const isOwn = c => own.indexOf(c.toUpperCase()) !== -1;
    const staffel = ['NACHBESTELLUNG5', 'NACHBESTELLUNG10', 'STARTERKIT2026'];

    if(!gcLieblingsActive(attrs)){
      if(current.some(isOwn)){
        await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({ discount: current.filter(c => !isOwn(c)).join(',') })
        });
        if(typeof gcRefreshCartSection === 'function') await gcRefreshCartSection();
      }
      return;
    }

    let dcQty = 0, boxQty = 0;
    cart.items.forEach(i => {
      if(i.variant_id === C.dcVariantId) dcQty += i.quantity;
      if(i.product_type === 'Testkit') boxQty += i.quantity;
    });

    const target = [];
    if(dcQty >= 1) target.push(C.deviceCode);
    const tier = gcLieblingsTier(boxQty);
    if(tier) target.push(tier.code);
    if(C.collabsCode) target.push(C.collabsCode);

    /* Normale Staffel immer raus - die LieblingsApotheken-Staffel ersetzt sie. */
    const rest = current.filter(c => !isOwn(c) && staffel.indexOf(c.toUpperCase()) === -1);
    const desired = target.concat(rest);

    const body = {};
    const same = desired.length === current.length && desired.every(c => current.indexOf(c) !== -1);
    if(!same) body.discount = desired.join(',');
    if(attrs.Partner !== 'LieblingsApotheken'){
      body.attributes = { lieblings_flow: 'true', Partner: 'LieblingsApotheken' };
    }
    /* Achtung: discount kann ein leerer String sein (alle Codes entfernen,
       z. B. wenn die Boxenzahl unter 5 faellt) - deshalb auf das
       Vorhandensein pruefen, nicht auf den Wert (Fix 06.10.2026). */
    const changeCodes = Object.prototype.hasOwnProperty.call(body, 'discount');
    if(!changeCodes && !body.attributes) return;

    await fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(body)
    });
    if(changeCodes && typeof gcRefreshCartSection === 'function') await gcRefreshCartSection();
  } catch(err){
    console.error('LieblingsApotheken-Check fehlgeschlagen:', err);
  }
}

(function(){
  const orig = window.gcEnforceMengenrabatt;
  window.gcEnforceMengenrabatt = async function(){
    if(typeof orig === 'function') await orig.apply(this, arguments);
    await gcEnforceLieblings();
  };
})();
